import { QueryClientProvider} from "react-query";
import {ReactQueryDevtools} from 'react-query/devtools'
import Index from "./pages/"
import "./css/pagination.css"
import {useQueryContext} from "./contexts/query";
import MainContextProvider from "./contexts/main";


/**
 * @global
 * @typedef {Object} UseQuery
 * @property {Object|undefined} [data] - response data
 * @property {Function} [refetch] - refetch api -- return promise
 * @property {boolean} [isLoading] - first loading
 * @property {boolean} [isFetching] - any refetching
 */

/**
 * @global
 * @typedef {Object} UseMutation
 * @property {Object|undefined} [data] - response data
 * @property {VoidFunction} [mutate] - refetch api
 * @property {boolean} [isLoading] - loading
 */

/**
 * @global
 * @typedef {Object} SocketOrder
 * @property {string} type - buy | sell
 * @property {number} amount
 * @property {number} price
 * @property {number} priceUnit
 */




function App() {
    const {queryClient} = useQueryContext()

    return (
    <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools />
        <MainContextProvider>
            <Index />
        </MainContextProvider>
    </QueryClientProvider>
    );
}


export default App;
